const status = {
  PATIENT: 'Please enter the patient\'s first or last name',
};

// eslint-disable-next-line import/prefer-default-export
export { status };
